
import { Dialog, Toast } from "vant";

// 微信登录
const $wx_authorize_url = function (redirectUrl) {
  budo_log.info("#7 wx_authorize_url, redirectUrl=" + redirectUrl)

  // login-success 后 回跳地址
  localStorage.setItem("budo.v2_redirect_url", redirectUrl);

  if (/(micromessenger)/i.test(navigator.userAgent)) {
    return "/v5/weixin-authorize?origin=" + location.origin;
  }

  // 非微信环境
  return "/v4/login";
}

const $go_wx_login_url = function (redirectUrl) {
  budo_log.info("#9 $go_wx_login_url, redirectUrl=" + redirectUrl);

  // sessionStorage 每次进窗口重新来
  var flag = sessionStorage.getItem("budo.confirm-go-login")
  if (flag && Date.now() - Number(flag) > 1000) { // 如果有这个标识 表示不是第一次 就确认一下
    Dialog.confirm({ message: "跳转到登录?" }).then(() => {
      location.href = $wx_authorize_url(redirectUrl)
    })
    return
  }

  Toast("登录 ...");

  // 写一下标记 再来就不是首次了
  sessionStorage.setItem("budo.confirm-go-login", Date.now())

  // 没有标识 表示首次 直接跳
  location.href = $wx_authorize_url(redirectUrl)
}

const cookie_get = function (name) {
  var cookies = document.cookie.split(';')
  name = name + "="
  for (var i = 0; i < cookies.length; i++) {
    var cookie = cookies[i].trim()
    if (cookie.indexOf(name) == 0) {
      return cookie.substring(name.length, cookie.length)
    }
  }
  return ""
}

export {
  cookie_get,
  $wx_authorize_url,
  $go_wx_login_url
}